// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table[data-v-8a9740fe] {\r\n  border-spacing: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
